module.exports = __webpack_public_path__ + "images/Xiaomi-aada09.png";